<template>
  <header class="bg-header py-2">
    <div class="container">
      <div class="d-flex justify-content-between align-items-center">
        <template v-if="!!logo">
          <img v-if="isLogoProperlyLoaded" :src="logoUrl" height="43" @error="handleImageError"/>
          <template v-else>
            <i class="fa fas fa-paw text-header-color" style="font-size: 2.75rem"></i>
          </template>
        </template>
        <template v-else>
          <i class="fa fas fa-paw fa-1x text-header-color" style="font-size: 2.75rem"></i>
        </template>
        <div class="text-header-color">
          <div class="font-size-h3 font-weight-bold">
            {{ selectedCompanyName }}
          </div>
          <p class="p2 mb-0">{{ selectedTagLine }}</p>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { BrandingSettingMixin } from '@/mixins/Booking/BrandingSettingMixin'
import { LogoCacheMixin } from '@/mixins/Booking/LogoCacheMixin'

export default {
  name: 'PageHeader',
  mixins: [LogoCacheMixin, BrandingSettingMixin],
  data () {
    return {
      isLogoProperlyLoaded: true
    }
  },
  methods: {
    handleImageError () {
      if (this.logo) {
        this.isLogoProperlyLoaded = false
      }
    }
  }
}
</script>
